import React, { useEffect, useState, useCallback } from "react"
import {
    Button,
    Card,
    CardBody,
    CardText,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap"

import { Link } from "react-router-dom"
import { Field as AvField, Form as AvForm } from "@availity/form"
import Dropzone from "react-dropzone"
import axios from "axios"

import { useWallet } from "../../libs/useMetaMaskWallet"
import Web3 from "web3"
import { ethers } from "ethers"
import { Provider, utils, Wallet, Web3Provider } from "zksync-web3"
import erc20Abi from "../../abi/MyERC20.json"
import nftAbi from "../../abi/BaseRoyaltyCappedNFTFC.json"
import ConnectWallet from "../../Components/ConnectWallet"
import BreadCrumb from "../../Components/BreadCrumb"
import { formatNumber, avgGasPrice } from "../../utils"
import { useToast } from "../../hooks/toast"
import { mintArtNFT } from "./mintingUtils"

import zkNftAbi from "../../abi/ZkStandardNFTCollection.json"

const parts = window.location.hostname.split(".") // ['swordsofblood', 'idexo', 'com'], ['localhost'], or ['app', 'idexo', 'io']
const subdomain = parts[0]

// const nftContract = "0x83F2BeB59A164740ff4723E5BF7aCE093953E023" //zk main
const nftContract = "0xd0767d49E0E30b8fB4484D86f0bD1f80aBc3e74C" //alt
const key = "ElrmS0e7IB4ObOoAoBfOzayROzEOzVlL9eMQJXWE"

// const nftContract = "0x389C769883dECa0743fdF63c0CAf40787036b138" //zk companions
const admin = "0x8142409931f554d99013de129cdDc70EA016d62d"
const mintPass = "0x2BC96F27618Da97A0113afA8EC1d6d36dA24887F" //contract to check if they have to validate entry
const erc20zkc = "0x4a248ef75c909B990F251a02D8F9eB4E26C329Fa"
const erc20Paymaster = "0xbbDF698Cc1B86D5AF67Ba674aC3fEa7E668C32c6"
const erc721Paymaster = "0x5396C3151F54D907E4743996C499621Bb403A1AE"

const companions = {
    victor: "https://arweave.net/Vk5SdkVLUrO3KtA3Rt2CuAWv-lwufRXORGNo4_ZHHtI",
    alyssa: "https://arweave.net/yp0rfd6BhG5OlzS6uU3Ssi52_Hzyj6GfShHtnLeAbF0",
    fae: "https://arweave.net/orAdnp0Sdjj9kWD0RGUPdRelnW-0CV8zIIs-sL4rZtE"
}

const erc20PaymasterParams = utils.getPaymasterParams(erc20Paymaster, {
    type: "ApprovalBased",
    token: erc20zkc,
    minimalAllowance: ethers.BigNumber.from(5),
    innerInput: new Uint8Array()
})

const paymasterParams = utils.getPaymasterParams(erc721Paymaster, {
    type: "General",
    innerInput: new Uint8Array()
})

function isBase64String(str) {
    return str.length % 4 == 0 && /^[A-Za-z0-9+/]+[=]{0,2}$/.test(str)
}

function isStringURL(str) {
    var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
    return regexp.test(str)
}

function detectMimeType(b64) {
    for (var s in base64Signatures) {
        if (b64.indexOf(s) === 0) {
            return base64Signatures[s]
        }
    }
}

function headers(apiKey) {
    return {
        "Content-Type": "application/json",
        "x-api-key": apiKey
    }
}

const base64Signatures = {
    JVBERi0: "application/pdf",
    R0lGODdh: "image/gif",
    R0lGODlh: "image/gif",
    iVBORw0KGgo: "image/png",
    "/9j/": "image/jpg",
    U: "image/webp"
}

// async function mintViaPaymaster() {
//     const gasPrice = await provider.getGasPrice()
//     console.log(gasPrice)
//     const theWallet = new Wallet(privateKey, provider)
//     const erc20 = new ethers.Contract(erc20zkc, tabi, theWallet)
//     const gasLimit = await erc20.estimateGas.mint(admin, 5, { //minting 5 tokens to the admin address
//         customData: {
//             gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
//             paymasterParams: paymasterParams
//         }
//     })
//     const fee = gasPrice.mul(gasLimit.toString())
//     console.log("Transaction fee estimation is :>> ", fee.toString())
//     await (
//     await erc20.mint(admin, 5, { //so you instantiate the target contract and add paymaster params and bootloader knows how to handle this
//       // paymaster info

//           customData: {
//             paymasterParams: paymasterParams,
//             gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
//           },

//     })
//   ).wait()
// }

// async function mintViaPaymaster721() {
//     const gasPrice = await provider.getGasPrice()
//     console.log(gasPrice)
//     const theWallet = new Wallet(privateKey, provider)
//     const erc20 = new ethers.Contract(erc20zkc, tabi, theWallet)
//     const gasLimit = await erc20.estimateGas.mint(admin, 5, { //minting 5 tokens to the admin address
//         customData: {
//             gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
//             paymasterParams: paymasterParams
//         }
//     })
//     const fee = gasPrice.mul(gasLimit.toString())
//     console.log("Transaction fee estimation is :>> ", fee.toString())
//     let mintAmount = ethers.utils.parseEther("5000000000000000000")
//     await (
//     await erc20.mint(admin, mintAmount, { //so you instantiate the target contract and add paymaster params and bootloader knows how to handle this
//       // paymaster info

//           customData: {
//             paymasterParams: paymasterParams,
//             gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
//           },

//     })
//   ).wait()
// }

// async function mintNFT(account, tokenUri) {
//     let senderAddress = '0x8142409931f554d99013de129cdDc70EA016d62d'
//     let gas = 8000000
//     let maxFeePerGas = 250000000
//     let maxPriorityFeePerGas = 250000000
//     Web3.providers.HttpProvider.prototype.sendAsync = Web3.providers.HttpProvider.prototype.send
//     const web3Provider = new HDWalletProvider(mnemonic, new Web3.providers.HttpProvider(zkTestRPC), 0, 10) // 1 replace 0, 10
//     const web3 = new Web3(web3Provider)
//     let tokenContract = new web3.eth.Contract(yoabi, nftContract)
//     let data = tokenContract.methods.mintNFT(account, tokenUri).encodeABI()
//         const tx = {
//             from: senderAddress,
//             to: nftContract,
//             data: data,
//             gas: gas,
//             maxFeePerGas: maxFeePerGas,
//             maxPriorityFeePerGas: maxPriorityFeePerGas,
//             chainId: 280,
//         }
//         let transactionHash = await web3.eth.sendTransaction(tx)
//         return transactionHash
// }

const ZkMinter = () => {
    const web3 = new Web3(window.ethereum)

    const [isLoading, setIsLoading] = useState(false)
    const [processingNFTMint, setProcessingNFTMint] = useState(false)
    const [processingTokenMint, setProcessingTokenMint] = useState(false)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [txModal, setTxModal] = useState(false)
    const [tx, setTx] = useState({
        status: "",
        hash: ""
    })
    const [selectedFiles, setSelectedFiles] = useState([])
    const [displayFiles, setDisplayFiles] = useState([])
    const [acceptedFiles, setAcceptedFiles] = useState([])
    const [imgFile, setImgFile] = useState(null)
    const [processing, setProcessing] = useState(false)
    const [name, setName] = useState("")
    const [description, setDescription] = useState("")
    const [attributes, setAttributes] = useState([{ name: "", value: "" }])
    const [mintToAddress, setMintToAddress] = useState("")
    const [network, setNetwork] = useState("zksync")

    const toast = useToast()
    const wallet = useWallet()

    const formatBytes = useCallback((bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }, [])

    const handleTx = (status, hash) => {
        setTx({ status: status, hash: hash })
    }

    const handleResetForm = async () => {
        window.location.reload()
    }

    const setMessage = async (type, message) => {
        switch (type) {
            case "success":
                toast.addSuccess(message)
                break
            case "error":
                toast.addError(message)
                break
            case "info":
                toast.addInfo(message)
                break
            default:
                break
        }
    }

    const handleMintNFT = async () => {
        web3.setProvider(wallet.ethereum.provider)
        setProcessing(true)
        //method on contract is mintNFT, doesn't take any input
        // console.log("name: " + name + " description: " + description + " image: " + JSON.stringify(selectedFiles[0]) + " attribute: " + JSON.stringify(attributes))
        const imageFile = selectedFiles[0].base64
        //get the token uri from current set data (name, description, image, attributes)
        // setProcessing(true)
        const tokenUriA = await uploadNFTMetadata(key, imageFile, name, description, attributes)
        const tokenUriB = tokenUriA.data.data.metadata_uri
        // console.log('token uri response: ' + JSON.stringify(tokenUriA.data))
        // console.log('token uri: ' + tokenUriB)

        // const tokenUri = "dummyfornow"

        mintArtNFT(web3, zkNftAbi, nftContract, wallet.account, tokenUriB, setProcessing, setMessage, handleResetForm)
    }

    const handleTxModal = (type) => {
        switch (type) {
            case "open":
                setTxModal(true)
                break
            case "close":
                setTxModal(false)
                setTx("", "")
                break

            default:
                break
        }
    }

    const sendRequest = async (apiKey, network, data, method = "post", params = null) => {
        let config = {
            method: method,
            url: "https://ziparweave.idexo.io",
            headers: headers(apiKey)
        }
        if (data) config.data = JSON.stringify(data)
        if (params) config.params = params
        return await axios.request(config).catch(function (error) {
            if (error.response) {
                return error.response
            } else {
                return error
            }
        })
    }

    const uploadNFTMetadata = async (apiKey, image, nftName, nftDescription, attributes) => {
        let contentType

        // // if image is string path to file
        // if (!isStringURL(image) && !isBase64String(image)) {
        //     contentType = mime.getType(image)
        //     image = await fs.readFile(image, { encoding: "base64" })
        // }
        if (isBase64String(image)) contentType = detectMimeType(image)
        if (contentType === undefined && !isStringURL(image)) throw "unsupported file type! image must be jpg, png, gif, webp, or pdf"

        const uploadType = "NFTMetadata"

        return await sendRequest(apiKey, network, {
            image,
            contentType,
            nftName,
            nftDescription,
            attributes,
            uploadType
        })
    }

    const handleCreateMetadata = async (image, nftName, nftDescription, attributes) => {
        const metadataId = await uploadNFTMetadata(key, image, nftName, nftDescription, attributes)
        console.log("metadata id: " + metadataId)
        // return metadataId
    }

    const [chainId, setChainId] = useState(undefined)
    const [account, setAccount] = useState(0)

    const handleSubmitButton = async (action, type) => {
        switch (action) {
            case "mintNFT":
                await mintNFTFunction()

                break

            case "mintTokens":
                await mintTokensFunction()

                break

            default:
                break
        }
    }

    const handleAcceptedFiles = async (files) => {
        const toBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () =>
                    resolve(
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                            formattedSize: formatBytes(file.size),
                            base64: reader.result.split(",")[1]
                        })
                    )
                reader.onerror = (error) => reject(error)
            })

        const base64Files = await Promise.all(files.map((file) => toBase64(file)))
        const fileZero = files[0]
        const filePreview = Object.assign(fileZero, {
            preview: URL.createObjectURL(fileZero)
        })
        setSelectedFiles(base64Files)
        setDisplayFiles([filePreview])
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        const attributesObj = {}
        attributes.forEach((attribute) => {
            attributesObj[attribute.name] = attribute.value
        })

        if (selectedFiles.length === 0 || selectedFiles[0].base64 === undefined) {
            alert("Please upload NFT image")
            return
        }

        if (network === "zksync") {
            const metadataId = await handleCreateMetadata(selectedFiles[0], name, description, attributes)
            // Assuming ido.React.mintBEP721 is available in the scope or imported
            // const result = await ido.React.mintBEP721(
            //     '0x6bd3a139ebad80fc95deeda14688b061971a415f',
            //     mintToAddress,
            //     selectedFiles[0].base64,
            //     selectedFiles[0].type,
            //     name,
            //     description,
            //     attributesObj,
            //     // Assuming jwt and localStorage are available in the scope
            // );

            // const { data, status, statusText } = result;
            // let status === 200;

            // if (status === 200) {
            //     alert(`NFT successfully minted. Address is: ${data}`);
            // } else {
            //     alert(`Minting NFT failed. StatusCode: ${status}. Reason: ${statusText}`);
            // }
        }
    }

    const mintTokensFunction = async () => {
        const provider = new Provider("https://testnet.era.zksync.dev")
        const signer = new Web3Provider(window.ethereum).getSigner()
        const gasPrice = await provider.getGasPrice()
        if (chainId === 280) {
            setProcessingTokenMint(true)
            try {
                const erc20contract = new ethers.Contract(erc20zkc, erc20Abi, signer)
                // const zkNFTcontract = new web3.eth.Contract(nftAbi, nftContract)
                const gasLimit = await erc20contract.estimateGas.mint(wallet.account, ethers.utils.parseEther("10"), {
                    //minting 5 tokens to the admin address
                    customData: {
                        gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
                        paymasterParams: erc20PaymasterParams
                    }
                })
                const fee = gasPrice.mul(gasLimit.toString())
                await (
                    await erc20contract.mint(wallet.account, ethers.utils.parseEther("10"), {
                        //so you instantiate the target contract and add paymaster params and bootloader knows how to handle this
                        // paymaster info

                        customData: {
                            paymasterParams: paymasterParams,
                            gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT
                        }
                    })
                )
                    // ).on("transactionHash", function (hash) {
                    //   handleTx("processing", hash)
                    // }).on("receipt", function (receipt) {
                    //   console.log(receipt)
                    //   if (receipt.status === true) {
                    //       setProcessingNFTMint(false)
                    //       handleTx("done", receipt.transactionHash)
                    //       toast.addSuccess(`NFT Successfully Minted`)
                    //   } else {
                    //       handleTx("error", receipt?.transactionHash)
                    //       toast.addError("Failed to Mint")
                    //       setProcessingNFTMint(false)
                    //   }
                    // })
                    .wait()
                    .then((receipt) => {
                        // console.log(receipt)
                        toast.addSuccess(`Tokens Successfully Minted`)
                    })
            } catch (error) {
                setProcessingTokenMint(false)
                console.log(error)
            }
        } else {
            toast.addInfo(`Select the zkSync Testnet network in your Metamask!`)
        }
        setProcessingTokenMint(false)
    }

    const mintNFTFunction = async () => {
        // const provider = new ethers.providers.Web3Provider(window.ethereum)
        const provider = new Provider("https://testnet.era.zksync.dev")
        const signer = new Web3Provider(window.ethereum).getSigner()
        const gasPrice = await provider.getGasPrice()
        if (chainId === 280) {
            setProcessingNFTMint(true)
            try {
                const erc721contract = new ethers.Contract(nftContract, nftAbi, signer)
                // const zkNFTcontract = new web3.eth.Contract(nftAbi, nftContract)
                const gasLimit = await erc721contract.estimateGas.mintNFT(wallet.account, companions.alyssa, {
                    //minting 5 tokens to the admin address
                    customData: {
                        gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
                        paymasterParams: paymasterParams
                    }
                })
                const fee = gasPrice.mul(gasLimit.toString())
                await (
                    await erc721contract.mintNFT(wallet.account, companions.alyssa, {
                        //so you instantiate the target contract and add paymaster params and bootloader knows how to handle this
                        // paymaster info

                        customData: {
                            paymasterParams: paymasterParams,
                            gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT
                        }
                    })
                )
                    // ).on("transactionHash", function (hash) {
                    //   handleTx("processing", hash)
                    // }).on("receipt", function (receipt) {
                    //   console.log(receipt)
                    //   if (receipt.status === true) {
                    //       setProcessingNFTMint(false)
                    //       handleTx("done", receipt.transactionHash)
                    //       toast.addSuccess(`NFT Successfully Minted`)
                    //   } else {
                    //       handleTx("error", receipt?.transactionHash)
                    //       toast.addError("Failed to Mint")
                    //       setProcessingNFTMint(false)
                    //   }
                    // })
                    .wait()
                    .then((receipt) => {
                        // console.log(receipt)
                        toast.addSuccess(`NFT Successfully Minted`)
                    })
            } catch (error) {
                setProcessingNFTMint(false)
                console.log(error)
            }
        } else {
            toast.addInfo(`Select the zkSync Testnet network in your Metamask!`)
        }
        setProcessingNFTMint(false)
    }

    useEffect(() => {
        ;(async () => {
            setIsConnectedToWallet(wallet.status === "connected")
            if (wallet.account) {
                try {
                    setAccount(wallet.account)
                    setChainId(wallet.chainId)
                } catch (err) {
                    console.log(err)
                }
            }
        })()
    }, [wallet, wallet.account])

    return (
        <React.Fragment>
            <div className="content">
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardBody>
                                <CardTitle className="h4">Mint NFT</CardTitle>
                                <p className="card-title-desc">Provide a name, description, and media file for your NFT</p>

                                <AvForm initialValues={{ nftname: "" }} onSubmit={handleSubmit}>
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup className="mb-3">
                                                <AvField
                                                    name="nftname"
                                                    label="Name"
                                                    placeholder="Enter NFT Name"
                                                    type="text"
                                                    onChange={(e) => setName(e.target.value)}
                                                    required
                                                />
                                            </FormGroup>
                                            <FormGroup className="mb-3">
                                                <AvField
                                                    name="metadescription"
                                                    label="Description"
                                                    placeholder="Description"
                                                    type="textarea"
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    rows="5"
                                                    required
                                                />
                                            </FormGroup>
                                            <FormGroup className="mb-3">
                                                <Row>
                                                    <Col sm="6">
                                                        <Label>Attribute Name</Label>
                                                        {attributes.map((attribute, index) => (
                                                            <Input
                                                                key={`attribute_name_${index}`}
                                                                type="text"
                                                                className="form-control mb-1"
                                                                onChange={(e) => {
                                                                    const newAttributes = [...attributes]
                                                                    newAttributes[index].trait_type = e.target.value
                                                                    setAttributes(newAttributes)
                                                                }}
                                                                value={attribute.trait_type}
                                                            />
                                                        ))}
                                                    </Col>
                                                    <Col sm="6">
                                                        <Label>Value</Label>
                                                        {attributes.map((attribute, index) => (
                                                            <Input
                                                                key={`attribute_value_${index}`}
                                                                type="text"
                                                                className="form-control mb-1"
                                                                onChange={(e) => {
                                                                    const newAttributes = [...attributes]
                                                                    newAttributes[index].value = e.target.value
                                                                    setAttributes(newAttributes)
                                                                }}
                                                                value={attribute.value}
                                                            />
                                                        ))}
                                                    </Col>
                                                </Row>
                                                <Button color="primary" onClick={() => setAttributes([...attributes, { trait_type: "", value: "" }])}>
                                                    Add Attribute
                                                </Button>
                                            </FormGroup>
                                        </Col>

                                        <Col sm="6">
                                            <FormGroup className="mb-3">
                                                <Label for="dropzone">Add Image</Label>
                                                <div className="dropzone">
                                                    {selectedFiles.length === 0 ? (
                                                        <Dropzone onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}>
                                                            {({ getRootProps, getInputProps }) => (
                                                                <div {...getRootProps({ className: "dropzone" })}>
                                                                    <input {...getInputProps()} />
                                                                    <div className="dz-message needsclick">
                                                                        <div className="mb-3">
                                                                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                                        </div>
                                                                        <h4>Drop files here or click to upload.</h4>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Dropzone>
                                                    ) : (
                                                        <Dropzone onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}>
                                                            {({ getRootProps, getInputProps }) => (
                                                                <div {...getRootProps({ className: "dropzone-previews mt-3" })}>
                                                                    <input {...getInputProps()} />
                                                                    {displayFiles.map((file, index) => (
                                                                        <div key={index} className="dz-preview dz-file-preview">
                                                                            <div className="dz-image" style={{ width: "100%", height: "auto" }}>
                                                                                <img
                                                                                    src={file.preview}
                                                                                    alt={file.name}
                                                                                    style={{ width: "100%", height: "auto", objectFit: "contain" }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <div className="dz-message needsclick"></div>
                                                                </div>
                                                            )}
                                                        </Dropzone>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div className="d-flex flex-wrap gap-2">
                                        <Button
                                            className="btn submit-btn w-100 blue-btn text-uppercase"
                                            onClick={() => handleMintNFT()}
                                            style={{ width: "100%" }}
                                        >
                                            {!processing ? "Mint " : "Processing... "}
                                            {processing ? <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" /> : null}
                                        </Button>
                                    </div>
                                </AvForm>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default ZkMinter
